import { render, staticRenderFns } from "./HomepageSliderRowComponent.vue?vue&type=template&id=8bf49f70&scoped=true&"
import script from "./HomepageSliderRowComponent.vue?vue&type=script&lang=js&"
export * from "./HomepageSliderRowComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomepageSliderRowComponent.vue?vue&type=style&index=0&id=8bf49f70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf49f70",
  null
  
)

export default component.exports